import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.scss";
import Home from "./pages/Home";
import Error404 from "./pages/Error404";
import Dashboard from "./pages/Dashboard";
import MobileOTP from "./pages/MobileOTP";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import MyProfile from "./pages/MyProfile";
import 'react-loading-skeleton/dist/skeleton.css';
import 'mdbreact/dist/css/mdb.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import AbandonedOrder from "./pages/AbandonedOrder";
import AllOrders from "./pages/AllOrders";
import OrderDetail from "./pages/OrderDetail";
import RetentionPage from "./pages/RetentionPage";
import RetentionCustomer from "./pages/RetentionCustomer";
import SkinrangeOrders from "./pages/SkinrangeOrders";
import RahulSkinrage from "./pages/RahulSkinrage";
import WhatsappLeads from "./pages/WhatsappLeads";


function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mobile-otp" element={<MobileOTP />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/all-orders" element={<AllOrders />} />
          <Route path="/abandoned-orders" element={<AbandonedOrder />} />
          <Route path="/order-detail/:ordernumber" element={<OrderDetail />} />
          <Route path="/retention" element={<RetentionPage />} />
          <Route path="/retention-customer/:mobile" element={<RetentionCustomer />} />
          <Route path="/skinrange-orders" element={<SkinrangeOrders />} />
          <Route path="/rahul-skinrange-orders" element={<RahulSkinrage />} />
          <Route path="/whatsapp-leads" element={<WhatsappLeads />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer position="bottom-center" />
    </>
  );
}

export default App;
